import _implicitStylesheets from "./listingTile.css";
import _implicitScopedStylesheets from "./listingTile.scoped.css?scoped=true";
import _axImage from "ax/image";
import _axBadge from "ax/badge";
import _wdsContentTitle from "wds/contentTitle";
import _wdsContentText from "wds/contentText";
import _wdsStarRatings from "wds/starRatings";
import _wdsButton from "wds/button";
import _wdsTag from "wds/tag";
import _wdsTile from "wds/tile";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<a type-style="display-7" util-style="ellipsis" class="link${0}"${"a0:href"} rel="nofollow"${"a0:title"}${2}>${"t1"}</a>`;
const $fragment2 = parseFragment`<div class="image-container${0}"${"a0:size"}${2}><div class="loading-logo${0}"${2}></div></div>`;
const stc0 = {
  "type": "listingTile"
};
const stc1 = {
  "block": true
};
const stc2 = {
  "image-container": true
};
const stc3 = {
  "logo": true
};
const stc4 = {
  classMap: {
    "lwc-cmp": true,
    "title": true
  },
  props: {
    "level": "3"
  },
  key: 8
};
const stc5 = {
  classMap: {
    "title-badge-container": true
  },
  attrs: {
    "grid": "",
    "align-items": "spread"
  },
  key: 9
};
const stc6 = {
  attrs: {
    "bump": "right"
  },
  key: 12
};
const stc7 = {
  classMap: {
    "lwc-cmp": true,
    "publisher": true
  },
  props: {
    "maxLines": "1"
  },
  key: 14
};
const stc8 = {
  classMap: {
    "ratings-container": true
  },
  key: 15
};
const stc9 = {
  "lwc-cmp": true,
  "stars": true
};
const stc10 = {
  classMap: {
    "lwc-cmp": true,
    "description": true
  },
  props: {
    "maxLines": "4"
  },
  key: 18
};
const stc11 = {
  classMap: {
    "callToAction": true
  },
  key: 19
};
const stc12 = {
  "categories": true
};
const stc13 = {
  "badge": true
};
const stc14 = {
  attrs: {
    "grid": "",
    "axis": "row",
    "flow": "wrap"
  },
  key: 28
};
const stc15 = {
  classMap: {
    "lwc-cmp": true,
    "title": true
  },
  props: {
    "level": "",
    "isLoading": "true",
    "loadingWidth": "50%"
  },
  key: 32
};
const stc16 = {
  classMap: {
    "lwc-cmp": true,
    "publisher": true
  },
  props: {
    "isLoading": "true",
    "loadingWidth": "40%"
  },
  key: 33
};
const stc17 = {
  classMap: {
    "lwc-cmp": true,
    "stars": true
  },
  props: {
    "size": "xsmall",
    "spaceBetween": "xsmall",
    "readOnly": true
  },
  key: 34
};
const stc18 = {
  classMap: {
    "description": true
  },
  key: 35
};
const stc19 = {
  props: {
    "isLoading": "true",
    "loadingWidth": "80%"
  },
  key: 36
};
const stc20 = {
  props: {
    "isLoading": "true",
    "loadingWidth": "80%"
  },
  key: 37
};
const stc21 = {
  props: {
    "isLoading": "true",
    "loadingWidth": "60%"
  },
  key: 38
};
const stc22 = {
  classMap: {
    "categories": true
  },
  key: 39
};
const stc23 = {
  props: {
    "isLoading": "true",
    "loadingWidth": "60px"
  },
  key: 40
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, ncls: api_normalize_class_name, c: api_custom_element, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, t: api_text, k: api_key, i: api_iterator} = $api;
  const {_m0, _m1, _m2, _m3, _m4} = $ctx;
  return [!$cmp.isLoading ? api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
    props: stc0,
    key: 0,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
    }
  }, [api_element("div", {
    classMap: stc1,
    attrs: {
      "data-card-type": $cmp.cardType,
      "role": $cmp.role
    },
    key: 1,
    on: {
      "keydown": _m1 || ($ctx._m1 = api_bind($cmp.handleKeyPress))
    }
  }, [api_custom_element("wds-tile", _wdsTile, {
    props: {
      "variant": $cmp.cardType
    },
    key: 2
  }, [api_element("div", {
    className: api_normalize_class_name($cmp.variant),
    attrs: {
      "grid": "",
      "axis": $cmp.axis,
      "flow": $cmp.flow
    },
    key: 3
  }, [api_element("div", {
    classMap: stc2,
    attrs: {
      "size": $cmp.imageSize,
      "grid": "",
      "align-items": "spread"
    },
    key: 4
  }, [api_custom_element("ax-image", _axImage, {
    classMap: stc3,
    props: {
      "width": "64px",
      "height": "64px",
      "imgSrc": $cmp.image.url,
      "alt": $cmp.image.altText,
      "variant": $cmp.imageVariant
    },
    key: 5
  }), $cmp.showChatBadgeStacked ? api_custom_element("ax-badge", _axBadge, {
    props: {
      "text": $cmp.labelChatBadge,
      "variant": "outline",
      "icon": "chat",
      "iconDescription": "Speech bubble"
    },
    key: 6
  }) : null]), api_element("div", {
    attrs: {
      "size": $cmp.contentSize
    },
    key: 7
  }, [api_custom_element("wds-content-title", _wdsContentTitle, stc4, [api_element("div", stc5, [api_static_fragment($fragment1, 11, [api_static_part(0, {
    on: {
      "click": _m3 || ($ctx._m3 = api_bind($cmp.handleClick))
    },
    attrs: {
      "href": $cmp.listingUrl,
      "title": $cmp.title
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.title))]), $cmp.showChatBadgeQueued ? api_element("div", stc6, [api_custom_element("ax-badge", _axBadge, {
    props: {
      "text": $cmp.labelChatBadge,
      "variant": "outline",
      "icon": "chat",
      "iconDescription": "Speech bubble"
    },
    key: 13
  })]) : null])]), $cmp.showPublisher ? api_custom_element("wds-content-text", _wdsContentText, stc7, [api_text(api_dynamic_text($cmp.byPublisher))]) : null, api_element("div", stc8, [$cmp.showStars ? api_custom_element("wds-star-ratings", _wdsStarRatings, {
    classMap: stc9,
    props: {
      "size": "xsmall",
      "spaceBetween": "xsmall",
      "value": $cmp.rating,
      "reviewCount": $cmp.reviewsAmount,
      "readOnly": true,
      "labelPosition": "right",
      "ariaLabel": $cmp.screnReaderMessageForRating
    },
    key: 16
  }) : null, $cmp.showChatBadgeQueueTransparent ? api_custom_element("ax-badge", _axBadge, {
    props: {
      "variant": "outline",
      "text": $cmp.labelChatBadge,
      "icon": "chat"
    },
    key: 17
  }) : null]), api_custom_element("wds-content-text", _wdsContentText, stc10, [api_text(api_dynamic_text($cmp.description))]), $cmp.showListingAction ? api_element("div", stc11, [api_custom_element("wds-button", _wdsButton, {
    props: {
      "href": $cmp.listingUrl,
      "label": $cmp.staticLabels.moreDetails,
      "variant": "text"
    },
    key: 20
  })]) : null])]), $cmp.showCategories ? api_element("div", {
    slotAssignment: "footer",
    className: api_normalize_class_name($cmp.variant),
    key: 21
  }, [api_element("div", {
    classMap: stc12,
    attrs: {
      "size": $cmp.contentSize,
      "grid": "",
      "axis": "row",
      "flow": "wrap"
    },
    key: 22
  }, api_iterator($cmp.categories, function (category) {
    return api_custom_element("wds-tag", _wdsTag, {
      classMap: stc13,
      props: {
        "ariaLabel": category.ariaLabel,
        "href": category.filter,
        "text": category.name
      },
      key: api_key(23, category.id)
    });
  }))]) : null, $cmp.actions.length ? $cmp.showCategories ? api_element("div", {
    slotAssignment: "card-actions",
    className: api_normalize_class_name($cmp.variant),
    key: 24
  }, api_iterator($cmp.actions, function (action) {
    return api_element("div", {
      key: api_key(25, action.label)
    }, [api_custom_element("wds-button", _wdsButton, {
      className: api_normalize_class_name(action.customClassName),
      props: {
        "variant": "tertiary",
        "size": "xsmall",
        "label": action.label,
        "disabled": action.disabled,
        "iconPlacement": "end",
        "icon": action.icon
      },
      key: 26,
      on: {
        "click": api_bind(action.fn),
        "keydown": _m4 || ($ctx._m4 = api_bind($cmp.handleActionKeyPress))
      }
    })]);
  })) : null : null])])]) : null, $cmp.isLoading ? api_custom_element("wds-tile", _wdsTile, {
    props: {
      "variant": $cmp.cardType,
      "grid": true,
      "axis": "column"
    },
    key: 27
  }, [api_element("div", stc14, [api_static_fragment($fragment2, 30, [api_static_part(0, {
    attrs: {
      "size": $cmp.imageSize
    }
  }, null)]), api_element("div", {
    attrs: {
      "size": $cmp.contentSize
    },
    key: 31
  }, [api_custom_element("wds-content-title", _wdsContentTitle, stc15), $cmp.showPublisher ? api_custom_element("wds-content-text", _wdsContentText, stc16) : null, $cmp.showStars ? api_custom_element("wds-star-ratings", _wdsStarRatings, stc17) : null, api_element("div", stc18, [api_custom_element("wds-content-text", _wdsContentText, stc19), api_custom_element("wds-content-text", _wdsContentText, stc20), api_custom_element("wds-content-text", _wdsContentText, stc21)]), api_element("div", stc22, [api_custom_element("wds-content-text", _wdsContentText, stc23)])])])]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3pabv1v38m";
tmpl.legacyStylesheetToken = "undefined-_listingTile";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
